import React, { useState } from "react";
import { useContainer } from "unstated-next";

import Logo from "./Logo";
import Links from "./Links";
import SearchInput from "../Form/SearchInput";
import ThemeToggler from "./Icons/ThemeToggler";
import Hamburger from "hamburger-react";
import SideDrawer from "../Drawer/SideDrawer";
import SearchIcon from "./Icons/SearchIcon";
import Logout from "./Icons/Logout";
import Login from "./Icons/Login";
import Tokens from "../../../store/tokens";

const Navbar: React.FC = () => {
  const { requestToken } = useContainer(Tokens);

  const [isMenuDrawerShown, setIsMenuDrawerShown] = useState<boolean>(false);
  const [isSearchDrawerShown, setIsSearchDrawerShown] = useState<boolean>(false);
  const [isDark, setIsDark] = useState(document.body.classList.contains("dark"));

  const toggleTheme = () => {
    document.body.classList.toggle("dark");
    setIsDark((prevState) => !prevState);
  };

  const toggleMenuDrawer = () => {
    setIsMenuDrawerShown((prev) => !prev);
    setIsSearchDrawerShown(false);
  };

  const toggleSearchDrawer = () => {
    setIsSearchDrawerShown((prev) => !prev);
    setIsMenuDrawerShown(false);
  };

  const closeDrawer = () => {
    setIsMenuDrawerShown(false);
    setIsSearchDrawerShown(false);
  };

  return (
    <>
      <SideDrawer isShown={isMenuDrawerShown}>
        <Links inSideDrawer={true} onClick={closeDrawer} />
        <hr className="bg-gray-900 dark:bg-white mb-5" />

        <div className="flex flex-row justify-between">
          <p className="defaultText">{isDark ? "Dark" : "Light"} mode</p>
          <ThemeToggler isDark={isDark} onClick={toggleTheme} inSideDrawer={true} />
        </div>

        <div className="flex flex-row justify-between mt-4">
          <p className="defaultText">{requestToken ? "Logout" : "Login to TMDb"}</p>
          {requestToken ? <Logout inSideDrawer={true} /> : <Login inSideDrawer={true} onClick={closeDrawer} />}
        </div>
      </SideDrawer>

      <SideDrawer isShown={isSearchDrawerShown}>
        <SearchInput onClickResult={closeDrawer} />
      </SideDrawer>

      <nav className="navbar">
        <div className="flex flex-row items-center">
          <Logo heightClass="h-10" />
          <div className="hidden md:block ml-10">
            <Links />
          </div>
        </div>

        <div className="md:hidden flex flex-row items-center">
          <SearchIcon className="w-6 h-6 stroke-current text-white" onClick={toggleSearchDrawer} />
          <Hamburger toggled={isMenuDrawerShown} toggle={toggleMenuDrawer} color="white" size={20} />
        </div>

        <div className="hidden md:flex md:flex-row md:items-center relative">
          <SearchInput />
          <div className="px-1"></div>
          <ThemeToggler isDark={isDark} onClick={toggleTheme} />
          {requestToken ? <Logout /> : <Login />}
        </div>
      </nav>
    </>
  );
};

export default Navbar;
